export default __webpack_public_path__ + "assets/models/f9ac2e87633f73ca694a85a4ec03aadc.glb";